import { compose, createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import { thunk } from 'redux-thunk';


import { rootReducer } from "./root-reducer";

// Add thunk to middleware
const middleWares = [
	process.env.NODE_ENV !== "production" && logger,
	thunk // Add thunk to the middleware array
].filter(Boolean);

// const middleWares = [process.env.NODE_ENV !== "production" && logger].filter(
// 	Boolean
// );

const composedEnhancer =
	(process.env.NODE_ENV !== "production" &&
		window &&
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
	compose;

const composedEnhancers = composedEnhancer(applyMiddleware(...middleWares));

export const store = createStore(rootReducer, undefined, composedEnhancers);
